import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { Module } from '../référentiel-métier-parcours/models/module.model';
import { ModuleService } from '../référentiel-métier-parcours/parcours-module/parcours-module.service';
import { ModuleStore } from '../référentiel-métier-parcours/parcours-module/store/module.store';
import { EtapeStore } from '../référentiel-métier-parcours/parcours-etape/store/etape.store';

export const moduleResolver: ResolveFn<Observable<Module> | undefined> = (route) => {
  const moduleService = inject(ModuleService);
  const moduleStore = inject(ModuleStore);
  const étapeStore = inject(EtapeStore);

  const id = route.queryParamMap.get('id');
  const type = route.queryParamMap.get('type');
  const idModule = route.paramMap.get('idModule');
  const module = idModule ?? id;

  if ((idModule === null && id !== null && type !== 'module') || module === null) {
    moduleStore.unselect();
    return undefined;
  }

  return moduleService.trouveParId(module).pipe(
    tap((module) => {
      moduleStore.modifierModule({ id: module.id, module });
      étapeStore.selection(module.idEtape);
      moduleStore.select({ id: module.id });
    }),
  );
};
